export default `<p style="text-align:center">
<strong><span style="font-family: 等线;font-size: 21px">《</span></strong><strong><span style="font-family: 等线;font-size: 21px">Ai优米APP隐私</span></strong><strong><span style="font-family: 等线;font-size: 21px">声明</span></strong><strong><span style="font-family: 等线;font-size: 21px">》</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">尊敬的用户，您好：</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">深圳市车安达汽保设备有限公司</span><span style=";font-family:等线;font-size:14px">（</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">下文简称</span><span style="font-family:等线">“A</span></span><span style=";font-family:等线;font-size:14px">i</span><span style=";font-family:等线;font-size:14px">优米</span><span style=";font-family:等线;font-size:14px">”“我们”和“我们的”）</span><span style=";font-family:等线;font-size:14px">深知隐私对您的重要性，并会尽全力保护您</span><span style=";font-family:等线;font-size:14px">的隐私。请在向</span><span style=";font-family:等线;font-size:14px">Ai优米提交个人数据之前，阅读、了解本《Ai</span><span style=";font-family:等线;font-size:14px">优米</span><span style=";font-family:等线;font-size:14px">App隐私声明》(下文简称“本政策”)。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">本政策适用于显</span><span style=";font-family:等线;font-size:14px">示本隐私政策、或链接至本隐私政策的</span><span style=";font-family:等线;font-size:14px">Ai优米网站和产品、服</span><span style=";font-family:等线;font-size:14px">务。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">本政策阐述了</span><span style=";font-family:等线;font-size:14px">Ai优米如何处理您的个人数据，但本政策可</span><span style=";font-family:等线;font-size:14px">能并不涉及所有可能的数据处理情境。有关收集产品或服务特定数据的信息由</span><span style=";font-family:等线;font-size:14px">Ai优米在补充政策中，</span><span style=";font-family:等线;font-size:14px">或</span><span style=";font-family:等线;font-size:14px">者在收集数据时</span><span style=";font-family:等线;font-size:14px">提供的通知中发布。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">我们制定本政策的目的在于帮助您了解以下内容：</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">1</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">Ai优米会如何使用您的个人数据</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">2</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">Ai优米会如何使用Cookie和同类技术</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">3</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">Ai优米会如何披露您的个人数据</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">4</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">Ai优米会如何保护您的个人数据</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">5</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">Ai优米会如何留存您的个人数据</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">6</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">如何查看和更新您的个人信息</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">7</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">第三方服务提供商</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">8、</span><span style=";font-family:等线;font-size:14px">本政策如何更新</span>
</p>
<p style="margin-left:28px">
<span style=";font-family:等线;font-size:14px">9</span><span style=";font-family:等线;font-size:14px">、联系我们</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">一、</span></strong><strong><span style="font-family: 等线;font-size: 19px">Ai优米会如何使用您的个人数据</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">个人数据是指在单独使用或结合其他信息使用时能够确定个人身份的信息。此类数据会在您使用优米产品或服务时被收集，包括姓名、手机号码、车牌信息、车辆信息、登录信息</span><span style=";font-family:等线;font-size:14px">(账户</span><span style=";font-family:等线;font-size:14px">号、密码</span><span style=";font-family:等线;font-size:14px">)，用户头像，上传的图片，积分，设备IP、国家地区</span><span style=";font-family:等线;font-size:14px">编码。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">Ai优米仅会出于本政策所述目的收集和使用您的个人数</span><span style=";font-family:等线;font-size:14px">据。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">下文举例说明了我们可能收集的个人数据以及我们如何使用此类数据：</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="margin-left:24px">
<span style="font-family:等线;font-weight:bold;font-size:14px">1.1&nbsp;</span><strong><span style="font-family: 等线;font-size: 14px">Ai优米收集的个人数据</span></strong>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">&nbsp;</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">我们会收集的个人数据，包括：姓名、手机号码、性别、车牌号、车架号、车型、发动机号、行驶证、</span><span style=";font-family:等线;font-size:14px">驾驶证</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">车辆信</span><span style=";font-family:等线;font-size:14px">息、出生日期、行业、职业、学历、籍贯、家庭住址、邮件、联系地址、公司名称、</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">登录信息</span>(账户号、密码)</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">用户头像</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px">上</span><span style=";font-family:等线;font-size:14px">传的图片、积分、国家地区编码。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">1</span></strong><strong><span style="font-family: 等线;font-size: 14px">.2 Ai优米会如何使用您的个人数据</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">我们会将您的个人数据用于以下目的：</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">登录账户</span></strong>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">&nbsp;</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">当您使用</span><span style=";font-family:等线;font-size:14px">Ai优米网站注册的账户登录本APP时，为了您能</span><span style=";font-family:等线;font-size:14px">正常使用我们提供的功能和服务，需要从我们网站获取您的账户信息，主要包括：企业名称、企业地址、手机号码、联系人信息、用户头像、用户</span><span style=";font-family:等线;font-size:14px">ID、邮箱、联系方式。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">账号注销</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">如果您需要注销您在</span><span style=";font-family:等线;font-size:14px">APP注册的账号，您可以通过致电13360066082</span><span style=";font-family:等线;font-size:14px">，</span><span style=";font-family:等线;font-size:14px">联系客服进行注销账号申请，我们会在</span><span style=";font-family:等线;font-size:14px">3</span><span style=";font-family:等线;font-size:14px">个工作</span><span style=";font-family:等线;font-size:14px">日内进行注销操作。注销账号意味着我们将终止向账号提供服务，并且您的</span><span style=";font-family:等线;font-size:14px">APP账号一旦被注销将不可恢复，请您在操作</span><span style=";font-family:等线;font-size:14px">之前自行备份相关所有信息和数据。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">意见反馈</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">为了更好的了解您对本</span><span style=";font-family:等线;font-size:14px">APP的使用情况，您可以</span><span style=";font-family:等线;font-size:14px">通过意见反馈功能向我们提交意见，在提交意见时会使用到用户</span><span style=";font-family:等线;font-size:14px">ID、电话以及邮箱，以便能及时处理您的反馈，也可拨打400-7166-756进行反馈您的宝贵意见</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">故障定位</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">当您使用本</span><span style=";font-family:等线;font-size:14px">APP发生异常或崩溃时，再次启动本APP后</span><span style=";font-family:等线;font-size:14px">，本</span><span style=";font-family:等线;font-size:14px">APP会将异常日志发送给Ai优米，让优米或其合作方提供</span><span style=";font-family:等线;font-size:14px">故障分析服务。异常日志内容包括：</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">崩溃信息、崩溃时间、</span>APP</span><span style=";font-family:等线;font-size:14px">的版本号、设备型号、设备操作系统。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">数据统计</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">为了持续改善产品设计，更好的为您服务，本</span><span style=";font-family:等线;font-size:14px">App 会统计</span><span style=";font-family:等线;font-size:14px">本</span><span style=";font-family:等线;font-size:14px">App中各功能的使用情况。为实现统计功能，本应用会收集</span><span style=";font-family:等线;font-size:14px">您的设备</span><span style=";font-family:等线;font-size:14px">IMEI、IMSI、国家地区编码</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">设备</span>IP</span><span style=";font-family:等线;font-size:14px">、</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">用户</span>ID</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">1.3收集和使用非识别性数据</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">非识别性数据是指无法用于确定个人身份的数据。例如</span><span style=";font-family:等线;font-size:14px">Ai优米会收集当前访问的页面的部分信息，例如访问的页面和</span><span style=";font-family:等线;font-size:14px">操作的响应事件。</span><span style=";font-family:等线;font-size:14px">Ai优米收集此数据的目的在于了解用户如何</span><span style=";font-family:等线;font-size:14px">使用自己的网站、产品和服务。借此，</span><span style=";font-family:等线;font-size:14px">Ai优米可以改善自己的</span><span style=";font-family:等线;font-size:14px">服务，更好地满足客户需求。</span><span style=";font-family:等线;font-size:14px">Ai优米可能会自行决定出于其他</span><span style=";font-family:等线;font-size:14px">目的收集、使用、处理、转移或披露非识别性数据。我们会尽力隔离您的个人数据和非识别性数据，并单独使用这两种数据。如果个人数据掺杂了非识别性数据，依旧会被视作个人数据处理</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">设备权限调用</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">存储权限</span></strong><span style=";font-family:等线;font-size:14px">：</span><span style=";font-family:等线;font-size:14px">用于将用户拍摄完毕的图片保存到本地等的文</span><span style=";font-family:等线;font-size:14px">件保存功能。当您使用本应用时，为了保证您安装的应用稳定运行，我们需要向您申请并获取此权限，并且我们承诺</span><span style=";font-family:等线;font-size:14px">仅读取</span><span style=";font-family:等线;font-size:14px">或缓存应用所必须的信息。如您不需要这样的服务，可以随时关闭该权限，这不会影响其他服务的使用。</span><span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">相机权限</span></strong><span style=";font-family:等线;font-size:14px">：</span><span style=";font-family:等线;font-size:14px">当您使</span><span style=";font-family:等线;font-size:14px">用拍摄照片、拍摄视频功能时，我们将访问您的设备相机相关权限，并收集您提供的拍摄照片后向我们上传图片、视频的信息。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px"><span style="font-family:等线">如您拒绝提供权限和内容的，仅会使您无法使用该功能。如您不需要这样的服务，可以随时关闭该权限，这不会影响其他服务的使用。您可以随时访问系统</span><span style="font-family:等线">”设置</span></span><span style=";font-family:等线;font-size:14px">&quot;来管理您的系统权</span><span style=";font-family:等线;font-size:14px">限。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">二、</span></strong><strong><span style="font-family: 等线;font-size: 19px">Ai优米会如何使用Cookie和同类技术</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">为确保网站正常运转，我们有时会在计算机或移动设备上存储名为</span><span style=";font-family:等线;font-size:14px">Cookie的小数据文件。Cookie是一种网络服务器存储</span><span style=";font-family:等线;font-size:14px">在计算机或移动设备上的纯文本文件。</span><span style=";font-family:等线;font-size:14px">Cookie的内容只能由创</span><span style=";font-family:等线;font-size:14px">建它的服务器检索或读取。每个</span><span style=";font-family:等线;font-size:14px">Cookie 对您的网络浏览器或移</span><span style=";font-family:等线;font-size:14px">动应用程序都是唯一的。</span><span style=";font-family:等线;font-size:14px">&nbsp;Cookie通常包含标识符、站点名称以</span><span style=";font-family:等线;font-size:14px">及一</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">些号码和字符。借助于</span>Cookie网站能够存储用户偏好</span><span style=";font-family:等线;font-size:14px">相关的数据。大多数大型网站或互联网服务提供商启用</span><span style=";font-family:等线;font-size:14px">Cookie</span><span style=";font-family:等线;font-size:14px">的目的在于改善用户体验。借助于</span><span style=";font-family:等线;font-size:14px">Cookie网站能够记住用户</span><span style=";font-family:等线;font-size:14px">的单次访问（</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">使用会话</span>Cookie) 或多次访问(便用永Cookie)</span><span style=";font-family:等线;font-size:14px">。借助于</span><span style=";font-family:等线;font-size:14px">Cookie网站能够保存设置，例如计算机或移动设备的语</span><span style=";font-family:等线;font-size:14px">言、字体、大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用</span><span style=";font-family:等线;font-size:14px">Cookie</span><span style=";font-family:等线;font-size:14px">，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一</span><span style=";font-family:等线;font-size:14px">个网页，该网站就不会</span><span style=";font-family:等线;font-size:14px">识别出您，而您会被再次注销。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">Ai优米不会将Cookie用于本政</span><span style=";font-family:等线;font-size:14px">策所述目的之外的任何用途。您可根据自己的偏好管理或删除</span><span style=";font-family:等线;font-size:14px">Cookie有关详情，请参见AboutCookies org。您可以清除计算</span><span style=";font-family:等线;font-size:14px">机上保存的所有</span><span style=";font-family:等线;font-size:14px">Cookie</span><span style=";font-family:等线;font-size:14px">，</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">大部分网络浏览器都设有阻止</span>Cookie的</span><span style=";font-family:等线;font-size:14px">功能。但如果您这么做，则需要在每一次访问我们的网站时</span><span style=";font-family:等线;font-size:14px">亲</span><span style=";font-family:等线;font-size:14px">自更改用户设置。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">如需详细了解如何更改浏览器设置，请访问以下链接</span><span style=";font-family:等线;font-size:14px">: slntemet Exlorer、</span><span style=";font-family:等线;font-size:14px">≤</span><span style=";font-family:等线;font-size:14px">Google Chrome2、&lt;MillaFirefoxe、&lt;Safariz 和&lt;Opera2。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">Ai优米不会将Cookie用于本文所述之外的任何其他目的，也</span><span style=";font-family:等线;font-size:14px">不会用于收集任何个人数据以满足任何其他目的。若无法读取</span><span style=";font-family:等线;font-size:14px">Cookie</span><span style=";font-family:等线;font-size:14px">，</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">则企业技术支持</span>APP功能将无法正常使用</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">三、</span></strong><strong><span style="font-family: 等线;font-size: 19px">Ai优米会如何披露您的个人数据</span></strong>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">只有符合下列情况时，</span><span style=";font-family:等线;font-size:14px">Ai优米才会披露您的个人数据。在</span><span style=";font-family:等线;font-size:14px">下列情形之外，</span><span style=";font-family:等线;font-size:14px">Ai优米绝不会将您的个人数据披露给第三方</span><span style=";font-family:等线;font-size:14px">。</span><span style=";font-family:等线;font-size:14px">在</span><span style=";font-family:等线;font-size:14px">获取明确同意的情况下披露获得您的明确同意后，</span><span style=";font-family:等线;font-size:14px">Ai优米会与</span><span style=";font-family:等线;font-size:14px">其他方共享您的个人数据。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">3.1披露给Ai优米的附属公司</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">您的个人数据可能会与</span><span style=";font-family:等线;font-size:14px">Ai优米的附属公司共享。作为项政策，我们只会披露必要的数据</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">3.2披露给授权合作伙伴</span></strong><strong><span style="font-family: 等线;font-size: 14px">（</span></strong><strong><span style="font-family: 等线;font-size: 14px"><span style="font-family:等线">下文简称</span><span style="font-family:等线">“我们的</span></span></strong><strong><span style="font-family: 等线;font-size: 14px"><span style="font-family:等线">合作伙伴</span><span style="font-family:等线">”）</span></span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">Ai优米的某些服务由我们的合作伙伴提供。Ai优米可能会与合作伙伴共享您的某些个人数据，以提供更好的客户服务和用户体验。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px"><span style="font-family:等线">例如，在您上网购买</span>Ai优米产品时，Ai优米必须与物流服务提供商共享您的个人数据才能安排送货，或者安排合作伙伴提供服务。我们仅会出于特定、明确而合法的目的处理您的个人数据，并且只会披露提供服务所必要的数据。Ai优米的子公司或合作伙伴无权将共享的个人数据用于任何其他用证</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">3.3基于法律或合理依据的披露</span></strong>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 14px">&nbsp;</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">在法律、法律程序、诉讼或公共和政府主管部门有要求的情况下，</span><span style=";font-family:等线;font-size:14px">Ai优米可能会披露您的个人数据。在某些管辖区，如果Ai优米牵涉到重组、合并或破产和清理诉讼，那么您的个人数据</span><span style=";font-family:等线;font-size:14px">不</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">会披露给交易方。</span>Ai优米</span><span style=";font-family:等线;font-size:14px">仅</span><span style=";font-family:等线;font-size:14px">会在存在合理需求的情况下披露您的数据，例如出于执行条款与条件以及保护客户的目的。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">四、</span></strong><strong><span style="font-family: 等线;font-size: 19px">Ai优米会如何保护您的个人数据</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">本</span><span style=";font-family:等线;font-size:14px">APP采取合理的预防措施，包括但不限于物理上、技术及制度等方面，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。例如，在技术方面本APP经过防病毒软件扫描确认，以及增强我们服务的攻击防护</span><span style=";font-family:等线;font-size:14px">；</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">物理方面，本</span>APP设定门禁措施及访问控制，仅允许需要这类信息的业务人员浏览</span><span style=";font-family:等线;font-size:14px">；</span><span style=";font-family:等线;font-size:14px"><span style="font-family:等线">在制度方面，则透过对</span>Ai优米员工进行安全与隐私保护知识培训，确保员工了解保护数据的重要性</span><span style=";font-family:等线;font-size:14px">。</span><span style=";font-family:等线;font-size:14px">虽然我们采用合理的措施来保护您的个人数据，但没有任何安全措施能够百分之百完美或牢不可破。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">五、</span></strong><strong><span style="font-family: 等线;font-size: 19px">Ai优米会如何查留存您的个人数据</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">本</span><span style=";font-family:等线;font-size:14px">APP将在必要的时间内保留您的个人数据，以便满足本</span><span style=";font-family:等线;font-size:14px">《隐私声明》规定的所有目的。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">六、如何查看和更新您的个人信息</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">根据</span><span style=";font-family:等线;font-size:14px">Ai优米的条款与条件，您可以随时管理自己的个人数据，例如您的联系信息。您应确保提交的所有个人数据都准确无误。Ai优米会尽力维护个人数据的准确和完整，并及时更新这些数据。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">您有权访问自己的个人数据，某些法律例外情况除外。如果某些管辖区的隐私和信息法有所不同，我们则会遵守这些法律。如果您需要查看或更新您的个人信息，请通过</span><span style=";font-family:等线;font-size:14px">A优米APP进行访问</span><span style=";font-family:等线;font-size:14px">，和</span><span style=";font-family:等线;font-size:14px">修改您的个人信息</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">七、第三方服务提供商</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">我们可能会与第三方服务供应商进行合作，第三方服务供应商提供相关某些产品或者服务，在该情况下第三方可能会共享用户信息。</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">在下列情况下，我们可能还会披露您的相关信：</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">根据法律、法规或法律程序</span><span style=";font-family:等线;font-size:14px">(如，法院法令或传召出庭令)的规定</span><span style=";font-family:等线;font-size:14px">；</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px"><span style="font-family:等线">根据政府部门</span>(如，行政机构、执法机构)的要求</span><span style=";font-family:等线;font-size:14px">；</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">为了保护本网站、我们的用户或其他人的权利及其财产或安全</span><span style=";font-family:等线;font-size:14px">，</span><span style=";font-family:等线;font-size:14px">或当我们认为对防止实际损害或财务损失，或调查可疑或实际非法活动来说，披露乃属必要或适当时。这也包括为防止欺诈等违法活动和减少信用风险而与其他公司和组织交换信息。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">我们希望您能够理解，我们可能会向第三方出售或转让本网站，和</span><span style=";font-family:等线;font-size:14px">/或允许承继方承继本网站的服务。在该等情况中，作为本网站不可分割一部分，您的个人信息也将被提供给该等第三方和/或承继方，以使其可以继续为您提供网站服务。接受本隐私声明意味着您已同意该等信息提供</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">八、本隐私政策如何更新</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。方披露您的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<strong><span style="font-family: 等线;font-size: 19px">九、联系我们</span></strong>
</p>
<p style="text-indent:28px">
<span style=";font-family:等线;font-size:14px">若是有任何疑问，或者您有相关的建议，欢迎致电：</span><span style=";font-family:等线;font-size:14px">深圳市车安达汽保设备有限公司400-7166-756</span><span style=";font-family:等线;font-size:14px">。</span>
</p>
<p>
<span style=";font-family:等线;font-size:14px">&nbsp;</span>
</p>
<p>
<br/>
</p>`